import React, { useEffect } from "react";
import { initializeAOS } from "../Aos";

const TermsAndConditions = () => {
    useEffect(() => {
        initializeAOS();
    }, []);

    return (
        <section className="bg-[#D9F4EF] py-16 md:py-28 px-4">
            <div
                className="container mx-auto max-w-5xl"
                data-aos="fade-up"
            >
                {/* Header */}
                <div className="mb-10">
                    <span className="inline-block mb-4 px-4 py-1 text-sm rounded-full bg-white text-gray-600">
                        Legal Information
                    </span>

                    <h2 className="text-[36px] md:text-[48px] leading-[1.15] font-semibold text-[#111827] mb-4">
                        Terms & Conditions
                    </h2>

                    <p className="text-gray-600 max-w-3xl leading-[28px]">
                        Please read these Terms & Conditions carefully before
                        using the InvexFlow platform and website.
                    </p>
                </div>

                {/* Content Card */}
                <div className="bg-white rounded-2xl shadow-sm border border-[#E5E7EB] p-6 md:p-10">

                    <div className="text-[#4B5563] text-[15px] md:text-[16px] leading-[30px] space-y-8">

                        <p>
                            Welcome to www.invexflow.com (the “Website”),
                            operated by InvexFlow (Pvt.) Ltd. (“InvexFlow”,
                            “we”, “us”, or “our”). By accessing or using our
                            Website, you agree to comply with and be bound by
                            the following Terms & Conditions (“Terms”). If you
                            do not agree with these Terms, please do not use
                            the Website.
                        </p>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                1. Acceptance of Terms
                            </h3>

                            <p>
                                By using this Website, you confirm that you are
                                at least 18 years old and legally capable of
                                entering into a binding agreement. If you are
                                accessing or using the Website on behalf of a
                                company or organization, you represent that you
                                have the authority to bind that entity to these
                                Terms.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                2. Website Purpose
                            </h3>

                            <p>
                                The Website provides general information about
                                InvexFlow, its services, and its business model,
                                including invoice financing, credit
                                facilitation, partnerships, and digital lending
                                enablement. It does not constitute financial
                                advice, offer, or solicitation of any kind.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                3. Use of Website
                            </h3>

                            <p className="mb-4">
                                You agree to use the Website for lawful purposes
                                only. You are prohibited from:
                            </p>

                            <ul className="space-y-3">
                                <li className="flex items-start gap-3 bg-[#D7F3EF] text-[#0F766E] text-sm font-medium px-4 py-3 rounded-lg">
                                    <span className="w-2 h-2 rounded-full bg-[#0F766E] mt-2" />
                                    Posting or transmitting any unlawful,
                                    harmful, defamatory, or obscene content
                                </li>

                                <li className="flex items-start gap-3 bg-[#D7F3EF] text-[#0F766E] text-sm font-medium px-4 py-3 rounded-lg">
                                    <span className="w-2 h-2 rounded-full bg-[#0F766E] mt-2" />
                                    Attempting to interfere with the Website’s
                                    functionality or security
                                </li>

                                <li className="flex items-start gap-3 bg-[#D7F3EF] text-[#0F766E] text-sm font-medium px-4 py-3 rounded-lg">
                                    <span className="w-2 h-2 rounded-full bg-[#0F766E] mt-2" />
                                    Copying, modifying, distributing, or
                                    exploiting Website content without
                                    authorization
                                </li>

                                <li className="flex items-start gap-3 bg-[#D7F3EF] text-[#0F766E] text-sm font-medium px-4 py-3 rounded-lg">
                                    <span className="w-2 h-2 rounded-full bg-[#0F766E] mt-2" />
                                    Using bots, crawlers, or scraping tools
                                    without our permission
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                4. Intellectual Property
                            </h3>

                            <p className="mb-4">
                                All content on this Website—including but not
                                limited to text, graphics, logos, icons, images,
                                videos, software, and trademarks—is the property
                                of InvexFlow or its licensors and is protected
                                by applicable copyright, trademark, and other
                                intellectual property laws.
                            </p>

                            <p>
                                You may not copy, reproduce, republish, upload,
                                or transmit any part of the Website without our
                                express written consent.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                5. Third-Party Content and Links
                            </h3>

                            <p>
                                The Website may contain links to third-party
                                websites or services for your convenience.
                                InvexFlow is not responsible for the content,
                                accuracy, or reliability of any third-party
                                resources. Visiting such sites is at your own
                                risk.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                6. No Financial Advice
                            </h3>

                            <p>
                                The content provided on this Website is for
                                informational purposes only and should not be
                                construed as legal, financial, or investment
                                advice. Please consult with qualified
                                professionals before making any business, legal,
                                or financial decisions.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                7. Privacy
                            </h3>

                            <p>
                                Your use of the Website is also governed by our
                                Privacy Policy, which explains how we collect,
                                use, and protect your personal information. By
                                using the Website, you consent to the collection
                                and use of your data as described in the Privacy
                                Policy.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                8. Disclaimer of Warranties
                            </h3>

                            <p className="mb-4">
                                The Website and all content, features, and
                                services are provided “as is” and “as available”
                                without any warranties of any kind, whether
                                express or implied. InvexFlow does not
                                guarantee:
                            </p>

                            <ul className="space-y-3">
                                <li className="flex items-start gap-3 bg-[#D7F3EF] text-[#0F766E] text-sm font-medium px-4 py-3 rounded-lg">
                                    <span className="w-2 h-2 rounded-full bg-[#0F766E] mt-2" />
                                    That the Website will be error-free or
                                    uninterrupted
                                </li>

                                <li className="flex items-start gap-3 bg-[#D7F3EF] text-[#0F766E] text-sm font-medium px-4 py-3 rounded-lg">
                                    <span className="w-2 h-2 rounded-full bg-[#0F766E] mt-2" />
                                    That defects will be corrected
                                </li>

                                <li className="flex items-start gap-3 bg-[#D7F3EF] text-[#0F766E] text-sm font-medium px-4 py-3 rounded-lg">
                                    <span className="w-2 h-2 rounded-full bg-[#0F766E] mt-2" />
                                    That the Website is free of viruses or
                                    harmful components
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                9. Limitation of Liability
                            </h3>

                            <p className="mb-4">
                                To the maximum extent permitted by law,
                                InvexFlow and its directors, employees,
                                affiliates, or agents shall not be liable for
                                any direct, indirect, incidental, special, or
                                consequential damages arising from:
                            </p>

                            <ul className="space-y-3">
                                <li className="flex items-start gap-3 bg-[#D7F3EF] text-[#0F766E] text-sm font-medium px-4 py-3 rounded-lg">
                                    <span className="w-2 h-2 rounded-full bg-[#0F766E] mt-2" />
                                    Your access to or use of the Website
                                </li>

                                <li className="flex items-start gap-3 bg-[#D7F3EF] text-[#0F766E] text-sm font-medium px-4 py-3 rounded-lg">
                                    <span className="w-2 h-2 rounded-full bg-[#0F766E] mt-2" />
                                    Any content or services provided on the
                                    Website
                                </li>

                                <li className="flex items-start gap-3 bg-[#D7F3EF] text-[#0F766E] text-sm font-medium px-4 py-3 rounded-lg">
                                    <span className="w-2 h-2 rounded-full bg-[#0F766E] mt-2" />
                                    Any unauthorized access to or use of our
                                    servers and data
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                10. Indemnification
                            </h3>

                            <p>
                                You agree to indemnify, defend, and hold
                                harmless InvexFlow and its affiliates,
                                officers, employees, and agents from and
                                against any and all claims, damages,
                                liabilities, costs, and expenses arising out of
                                your use of the Website or violation of these
                                Terms.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                11. Changes to Terms
                            </h3>

                            <p>
                                InvexFlow reserves the right to modify or
                                update these Terms at any time. Changes will be
                                posted on this page with the updated date.
                                Continued use of the Website after such changes
                                constitutes your acceptance of the revised
                                Terms.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                12. Governing Law
                            </h3>

                            <p>
                                These Terms shall be governed by and construed
                                in accordance with the laws of Pakistan, without
                                regard to its conflict of law principles. Any
                                disputes arising out of or relating to these
                                Terms shall be subject to the exclusive
                                jurisdiction of the courts located in Pakistan.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-xl font-semibold text-[#111827] mb-3">
                                13. Contact Us
                            </h3>

                            <p className="mb-4">
                                For any questions or concerns regarding these
                                Terms, please contact us:
                            </p>

                            <div className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl p-5">
                                <p className="font-semibold text-[#111827]">
                                    InvexFlow (Pvt.) Ltd.
                                </p>

                                <p className="text-gray-600 mt-2">
                                    Email: info@invexflow.com
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default TermsAndConditions;